<template>
  <div id="search">
    <img src="@/assets/image/h5/bg_guojiaguangdian.png" class="banner" alt="" />
    <div class="title">
      <h2>全媒体运营师职业技能等级证书查询</h2>
      <p>Vocational skill level certificate inquiry</p>
    </div>
    <div class="search">
      <el-form
        :model="form"
        ref="search"
        :rules="rules"
        :inline="true"
        size="normal"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="证书编号">
          <el-input v-model="form.certificate"></el-input>
        </el-form-item>
        <el-form-item label="身份号" prop="id_card">
          <el-input
            v-model="form.id_card"
            placeholder="请输入身份证号"
          ></el-input>
        </el-form-item>
        <div>
          <div id="action" @click="onSubmit">点击查询</div>
        </div>
      </el-form>
    </div>
    <div class="certificate" v-show="show" v-html="certificate"></div>
    <p class="bot_text">
      数据同步于国家广播电视总局广播电视和网络视听播音主持教育培训基地
    </p>
    <a
      href="https://beian.miit.gov.cn/publish/query/indexFirst.action"
      class="bottom"
      rel="noreferrer"
      target="_blank"
      >蜀ICP备2020032209号
    </a>
  </div>
</template>
<script>
export default {
  metaInfo() {
    return this.metaData;
  },
  data() {
    return {
      show: false,
      certificate: "",
      metaData: {
        title: "全媒体运营师培等级证书查询_泽谷传媒", // set a title
        meta: [
          {
            // set meta
            name: "keyWords",
            content:
              "网络视听主播培训、短视频运营培训、全媒体运营师培训职业技能等级证书查询",
          },
          {
            name: "description",
            content:
              "由国家广播电视总局教育培训基地主办与颁发全媒体运营师职业技能证书信息查询官网。",
          },
        ],
      },
      rules: {
        name: { required: true, message: "请输入姓名", trigger: "blur" },
        id_card: { required: true, message: "请输入身份证号", trigger: "blur" },
      },
      form: {
        name: "",
        id_card: "",
        certificate: "",
      },
    };
  },
  created(){
    this.$emit('showPC', false);
  },
  mounted() {
    if(!this.isMobile(navigator.userAgent)){
      let url = window.location.origin.replace(/m./, "www.")
        window.location.href= url+ '/page/search/search.html'
    }
  },
  methods: {
    // 判断是否为移动端
    isMobile(ua) {
      return !!ua.match(/AppleWebKit.*Mobile.*/)
    },
    onSubmit() {
      let that = this
      this.$refs.search.validate((valid) => {
        if (valid) {
          that.$axios.post("/search", that.form).then((res) => {
            if (res.code === 0) {
              that.show = true;
              that.certificate = res.data;
            }else{
              that.$message.error('搜索失败，请检查参数后查询')
            }
          }).catch(error=>{
            alert(error)
            // that.$message.error(error)
          });
        }
      });
    },
  },
};
</script>
<style lang="scss">
#search{  
.el-form--inline .el-form-item__label{
  display: block;
  text-align: left;
  line-height: 19px;
}
.el-input{
  width: 306px;
  height: 40px;
}
.certificate {
  .zs {
    width: 320px;
    height: auto;
    margin: 0 auto;
    border: 10px solid #f0f0f0;
    background: url(../../../assets/image/as.jpg) no-repeat center center;
    background-size: cover;
    padding: 20px 10px;
    box-sizing: border-box;
    text-align: center;
    p{
      margin-bottom: 0;
    }
  }
}
.zs img {
  max-width: 100%;
}
.zs h2{
  font-size: 16px;
  color: #333;
  font-family: 'fz';
}
.zs h3{
  font-size: 14px;
  color: #333;
  font-family: 'fz';
  padding-top: 10px;
}
.zs_text {
  padding:20px 0;
  font-size: 12px;
}
.zs_text p {
  vertical-align: middle;
  text-align: left;
  line-height: 20px;
}

.zs_text p i,
.zs_text p span {
  font-size: 12px;
  color: #000;
  font-style: normal;
}
.zs_btnm{
  display: flex;
}
.zs_btnm > div {
  display: inline-block;
  vertical-align: middle;
}
.zsbtm_l {
  text-align: left;
}
.zsbtm_l img {
  width: 110px;
  display: block;
}
.zsbtm_r {
  text-align: right;
}

.zsbtm_r h4 {
  font-size: 13px;
  color: #000;
  vertical-align: middle;
  display: inline-block;
  padding-right: 30px;
}
.zsbtm_rs {
  vertical-align: middle;
  display: inline-block;
  position: relative;
}
.zsbtm_rs img{
  max-width: 100%;
  position: absolute;
  width: 100px;
  left: 50%;
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
  -ms-transform: translateY(-50%) translateX(-50%);
  -moz-transform: translateY(-50%) translateX(-50%);
  -webkit-transform: translateY(-50%) translateX(-50%);
  -o-transform: translateY(-50%) translateX(-50%);   
}
.zsbtm_rs p {
  font-size: 12px;
  color: #000;
  line-height: 20px;
  text-align: center;
}
}
</style>
<style lang="scss" scoped>
#search {
  * {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  list-style: none;
  -moz-user-select: text; /*火狐*/
  -webkit-user-select: text; /*webkit浏览器*/
  -ms-user-select: text; /*IE10*/
  -khtml-user-select: text; /*早期浏览器*/
  user-select: text;
}
body{
  font-family:Tahoma,Arial,Roboto,"Droid Sans","Helvetica Neue","Droid Sans Fallback","Heiti SC",sans-self;
  -webkit-font-smoothing:antialiased; 
  /* 使字体变清晰 */
  -webkit-user-select:none;
  /* 不可选择文字 */
  -webkit-overflow-scrolling:touch;
  /* 区域性 overflow: scroll | auto 滚动时使用原生效果（ios8+，Android4.0+） */
}
.bot_text{
  color: #333333;
  font-size: 12px;
  text-align: center;
  margin-top: 10px;
}
.el-form-item{
  margin-bottom: 25px;
}
.banner{
  width: 100%;
  display: block;
  margin-bottom: 50px;
}
h2{
  font-size: 16px;
  color: #2B3748;
  font-weight: bold;
}
.title{
  text-align: center;
  line-height: 1;
}
.title p{
  font-size: 10px;
  color: #7D8A9C;
  margin-top: 10px;
}
.search{
  margin-top: 40px;
  width: 306px;
  margin: 40px auto ;
}
.search .item{
  margin-bottom: 25px;
}
.search label {
  display: block;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2B3748;
  padding-left: 5px;
}
.search label span {
  color: #EC2344;
}
#action{
  line-height: 38px;
  height: 38px;
  background: #0C81FE;
  border-radius: 4px;
  font-size: 14px;
  color: #FFFFFF;
  text-align: center;
}
.search input {
  background: none;
  outline: none;
  width: 306px;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #E0E0E0;
  border-radius: 5px;
  font-size: 14px;
  text-indent: 1em;
}


.bottom{
  color: #333333;
  font-size: 12px;
  text-decoration: none;
  display: block;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 15px;
  padding: 0 12px;
  text-align: center;
}

}
</style>